// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3849":"b5f9cf0c","5757":"93c93a17"}[chunkId] + ".chunk.css";
};